export default{
  '文本描述':'Text description',
  '单选':'Single Choice',
  "多选":"Multiple Choice",
  "填空":"Open-ended",
  "问答":"Open-ended",
  "量表":"Scale",
  "矩阵单选":"Matrix for single choice",
  "矩阵多选":"Matrix for multiple choice",
  "矩阵量表":"Matrix scale",
  "排序":"Ranking",
  "表格填空":"Open-ended in table",
  "附件上传":"Attachment upload",
  "附件":"Upload",
  "表格下拉(单选)":"Table dropdown (single choice)",
  "表格下拉":"Table dropdown",
  "定位":"location",
  "划线":"Underline",
	"矩阵限时判断": "Time-limited true or false question in matrix",
	"日历": "calendar",
	"满意度": 'Satisfaction',
	"认同度": 'Recognition',
	"重要度": 'Importance',
	"愿意度": 'Willingness',
	"符合度": 'Compliance',
	"自定义": 'custom',
	"自定义文字": 'Custom Text',
	"默认": 'Default',
	"滑块": 'Slider',
	"大拇指": 'Thumb',
	"笑脸": 'Smiling face',
	"星星": 'Star',
	"笑脸哭脸": 'Smiling/crying face',
	"勾叉": 'Tick/Cross',
	"满意": 'satisfied',
	"认同": 'agree',
	"重要": 'important',
	"愿意": 'willing',
	"符合": 'consistent',
  "手写签名":'Handwritten signature',
  "联动":'Linkage',
  "标注":'tagging'
}